import {useSelector} from 'react-redux';
import NewTicketsEvent from './NewTicketsEvent';
import NewHubEvent from './newHubEvent/NewHubEvent';
import NewGivechakEvent from './newGivechakEvent/NewGivechakEvent';
import NewLecturesEvent from './newLecturesEvent/NewLecturesEvent';
import NewAreaEvent from './newAreaEvent/NewAreaEvent';
import CreateSubscriptionEvent from './CreateSubscriptionEvent/CreateSubscriptionEvent';

function NewEvent() {
    const type=useSelector(s=>s.event.type);
    
    const generators={
        hub:NewHubEvent,
        givechak: NewGivechakEvent,
        timetable:NewLecturesEvent,
        area: NewAreaEvent,
        subscription: CreateSubscriptionEvent
    };

    const Comp=generators[type]||NewTicketsEvent;

    return (
        <Comp/>
    );
}

export default NewEvent;
